import Vue from 'vue';
import MenuComponent from '@app/modules/RF/CMS/Menu.vue';
export default Vue.extend({
    data: function () {
        return {
            name: this.$settings('owner.name'),
            address: this.$settings('owner.address'),
            phone: this.$settings('owner.phone'),
            email: this.$settings('owner.email')
        };
    },
    components: {
        MenuComponent: MenuComponent
    }
});
